import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteBlogTags } from "../../api/apiBlogTags";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي نهائي لوسوم المدونة
 */
export function useForceDeleteAllBlogTags() {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllBlogTagsMutate,
        isPending,
    } = useMutation({
        mutationFn: massForceDeleteBlogTags,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-tags"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete blog tags");
        },
    });

    return {
        forceDeleteAllBlogTagsMutate,
        isPending,
    };
}
